import { FC } from 'react';
import { LinkButton } from '../../components/buttons/LinkButton.client';
import { Heading } from '../../components/Heading.client';
import { Link } from '../../components/Link.client';
import { Categories } from '../home/Categories.client';

export const Error: FC = () => (
  <div>
    <div className="mb-24">
      <div className="mb-20 flex justify-center">
        <div className="max-w-[800px] px-6">
          <div className="mt-8 mb-6 md:mt-10 md:mb-5">
            <Heading title="ページが見つかりません" subTitle="404 NOT FOUND" />
          </div>
          <div className="mb-12">
            <p className="text-center text-sm">
              大変申し訳ございません。お探しのページは見つかりませんでした。
              <br />
              <br />
              ご指定いただいたアドレスが間違っているか、ページが移動または削除された可能性があります。
            </p>
          </div>
          <div>
            <Link route="home">
              <LinkButton title="ホームに戻る" subTitle="home" direction="left" />
            </Link>
          </div>
        </div>
      </div>
    </div>
    <Categories />
  </div>
);
